import {getService,postBodyService} from "./base.service";
import config from "../config/application";

//url
const listSocietiesByCountry = 'branch/societies/find_by_country';
const listCEntitiesBySociety = 'branch/collecting_entities/find_by';

const list = 'branch/list';
const add = 'branch/add';
const update = 'branch/update';
const deleteUrl = 'branch/delete';

class BranchService {
    //COMBO_BOX
    getSocieties(country) {
        const url = `${config.data.income.branch.url}${listSocietiesByCountry}/${country}`;
        return getService(url);
    }
    findBySociety(society) {
        const url = `${config.data.income.branch.url}${listCEntitiesBySociety}/${society}`;
        return getService(url);
    }
    //FORM
    getBranches(entity) {
        const url = `${config.data.income.branch.url}${list}/${entity}`;
        return getService(url);
    }
    saveBranch(branch){
        const url = `${config.data.income.branch.url}${add}`;
        return postBodyService(url,branch);
    }
    updateBranch(branch){
        
        const url = `${config.data.income.branch.url}${update}`;
        return postBodyService(url,branch);
    }
    deleteBranch(lsbranch){
        const url = `${config.data.income.branch.url}${deleteUrl}`;
        return postBodyService(url,lsbranch);
    }
    
}
export default new BranchService(); 